var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.fetchingAvailability) ? _c('div', {
    attrs: {
      "id": "table-wrapper"
    }
  }, [_c('grid', {
    attrs: {
      "others": _vm.others,
      "columns": _vm.tableConfigs.columns,
      "source": _vm.arrayToTable,
      "options": _vm.options,
      "lang": _vm.$root.token.idLingua,
      "name": _vm.name,
      "selectParameter": _vm.$Behaviors.focusBy(),
      "select": _vm.focus,
      "rowClick": _vm.rowClicked
    },
    on: {
      "update:source": function($event) {
        _vm.arrayToTable = $event
      },
      "API": _vm.assignGridAPI,
      "ready": _vm.setGridHeight
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseQty),
      expression: "chooseQty"
    }],
    staticStyle: {
      "position": "absolute",
      "left": "77px",
      "max-width": "200px",
      "width": "200px",
      "font-size": "small",
      "border-color": "rgb(167, 199, 220)",
      "background-color": "rgb(220, 235, 245)",
      "z-index": "9999",
      "border-style": "solid",
      "border-width": "0.1px"
    },
    style: (_vm.popupHeight),
    attrs: {
      "id": "purchasePopup"
    }
  }, [_c('div', {
    staticClass: "popup-arrow-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-arrow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px",
      "color": "rgb(107, 106, 106)",
      "font-size": "15px",
      "text-align": "center",
      "vertical-align": "middle",
      "border-bottom-style": "solid",
      "border-bottom-width": "1px",
      "border-color": "rgb(204, 204, 204)",
      "box-shadow": "rgb(228, 243, 251) 0px 1px 0px"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin-top": "4px",
      "float": "left",
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('purchase')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "cursor": "pointer",
      "float": "right",
      "margin-right": "5px",
      "margin-top": "2px"
    },
    on: {
      "click": function($event) {
        _vm.closePurchasePopup()
      }
    }
  }, [_c('i', {
    class: _vm.$root.icons.close
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "truncEllipsisMultiline"
  }, [_vm._v(_vm._s(_vm.purchaseDes))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "13px",
      "padding-left": "4px",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('code') + ': ' + _vm.purchaseSid))]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "purchasePopup.prezzo",
      "tag": "div"
    }
  }, [(_vm.purchasePrice) ? _c('div', {
    staticStyle: {
      "font-size": "13px",
      "padding-left": "4px",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('price') + ': ' + _vm.purchasePrice))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default dyn-btn-number",
    attrs: {
      "type": "button",
      "data-type": "minus",
      "data-field": "quant[1]"
    }
  }, [_c('span', {
    class: this.$root.icons.minus
  })])]), _vm._v(" "), _c('input', {
    staticClass: "form-control dyn-input-number",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "id": "popupquantita2Id",
      "name": "quant[1]",
      "value": ""
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default dyn-btn-number",
    attrs: {
      "type": "button",
      "data-type": "plus",
      "data-field": "quant[1]"
    }
  }, [_c('span', {
    class: this.$root.icons.plus
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "font-size": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.putInCart()
      }
    }
  }, [_c('span', {
    class: this.$root.icons.cart_in
  })])])], 1)])])], 1) : _vm._e(), _vm._v(" "), (_vm.fetchingAvailability) ? _c('div', {
    staticClass: "sk-cube-grid",
    staticStyle: {
      "position": "absolute",
      "top": "20%",
      "left": "50%"
    }
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9 loading-nav-waiter"
  })]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45277e8f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/DynTableWrapper.vue
// module id = 1643
// module chunks = 1